module.exports = __webpack_public_path__ + "26fe10205ee856004a4781708f6216c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/centene_2023_chart.png
// module id = 1649
// module chunks = 0